import { render, staticRenderFns } from "./leagueold.vue?vue&type=template&id=45252ec9&lang=pug&"
import script from "./leagueold.vue?vue&type=script&lang=js&"
export * from "./leagueold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports